<div mat-dialog-content>
  {{message}}
</div>
<div mat-dialog-actions>
  <button (click)="onNoClick()" mat-button>Annuler</button>
  <button [mat-dialog-close]="true" cdkFocusInitial mat-button>Valider</button>
</div>
